import { useCallback, useEffect, useState } from 'react';
import { ProdutoMaquinaProps } from '../shared/types/ProdutoMaquinaProps';
import { useForm } from './useForm';
import { MaquinaDetalheSchemas } from '../schemas/MaquinaDetalheSchema';
import { useNavigate } from 'react-router-dom';
import { Maquina } from '../routes/RoutesNames';
import { toast } from 'react-toastify';
import ProdutoController from '../controllers/ProdutoController';
import MarcaController from '../controllers/MarcaController';
import ModeloController from '../controllers/ModeloController';
import { SelectAutoCompleteOptions } from '../shared/types/selectAutoComplete';

const useMaquinaCadastrar = (MaquinaId?: number) => {
  const navigation = useNavigate();

  const [maquina, setMaquina] = useState<ProdutoMaquinaProps | any>({
    Descricao: '',
    ProdutoId: null,
    Marca: '',
    Modelo: '',
    NumeroSerie: '',
    TipoMaquina: '',
    Grupo: 7,
    Observacao: '',
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [marcaOptions, setMarcaOptions] = useState<SelectAutoCompleteOptions[]>([]);
  const [modeloOptions, setModeloOptions] = useState<SelectAutoCompleteOptions[]>([]);

  const onSubmit = async (data: ProdutoMaquinaProps) => {
    setLoading(true);
    if (MaquinaId) {
      const response = await ProdutoController.AtualizarMaquina({
        ProdutoId: MaquinaId,
        Marca: data.Marca?.toUpperCase(),
        Modelo: data.Modelo?.toUpperCase(),
        Observacao: data.Observacao,
        Grupo: data.Grupo,
        NumeroSerie: data.NumeroSerie,
        TipoMaquina: data.TipoMaquina,
      });

      if (response.StatusCode === 204) {
        toast('Máquina atualizada com sucesso!', {
          type: 'success',
        });
      }
    } else {
      const response = await ProdutoController.Adicionar({
        ProdutoId: null,
        Descricao: data.Marca + ' '+ data.Modelo + ' ' + data.NumeroSerie,
        Marca: data.Marca?.toUpperCase(),
        Modelo: data.Modelo?.toUpperCase(),
        Observacao: data.Observacao,
        Grupo: data.Grupo,
        NumeroSerie: data.NumeroSerie,
        TipoMaquina: data.TipoMaquina,
      });

      if (response.StatusCode === 204) {
        toast('Máquina cadastrada com sucesso!', {
          type: 'success',
        });
      }
      navigation(Maquina);
    }
    setLoading(false);
  };

  const backActions = () => {
    navigation(Maquina);
  };

  // Marca/Modelo: busca nas respectivas tabelas ao digitar (mesmo padrao do campo Cliente em Vendas).
  // O valor continua sendo texto (prod_marca/prod_modelo); o autocomplete apenas assiste a digitacao.
  const handleSearchMarca = async (value: string) => {
    form.setFieldValue('Marca', (value ?? '').toUpperCase());
    if (!value) { setMarcaOptions([]); return; }
    const result = await MarcaController.Listar({ Descricao: value, UsuId: 0 });
    if (result.StatusCode === 200 && Array.isArray(result.Data)) {
      setMarcaOptions(
        result.Data.map((item: any) => ({ value: String(item.mar_id), label: item.mar_descricao }))
      );
    }
  };

  const handleSelectMarca = (value: any) => {
    form.setFieldValue('Marca', ((value?.label ?? value) ?? '').toString().toUpperCase());
  };

  const handleSearchModelo = async (value: string) => {
    form.setFieldValue('Modelo', (value ?? '').toUpperCase());
    if (!value) { setModeloOptions([]); return; }
    const result = await ModeloController.Listar({ Descricao: value, UsuId: 0 });
    if (result.StatusCode === 200 && Array.isArray(result.Data)) {
      setModeloOptions(
        result.Data.map((item: any) => ({ value: String(item.mod_id), label: item.mod_descricao }))
      );
    }
  };

  const handleSelectModelo = (value: any) => {
    form.setFieldValue('Modelo', ((value?.label ?? value) ?? '').toString().toUpperCase());
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: maquina,
    validationSchema: MaquinaDetalheSchemas,
  });

  const getMaquinaById = useCallback(async () => {    
    console.log('ID: '+ MaquinaId)
    if (!MaquinaId) return;
    try {
      const Response = await ProdutoController.ListarUnicoMaquina(MaquinaId);
      if (Response.Data) {
        setMaquina({
          Descricao: Response.Data.prod_descricao,
          Marca: Response.Data.prod_marca,
          Modelo: Response.Data.prod_modelo,
          NumeroSerie: Response.Data.prod_numSerie,
          TipoMaquina: Response.Data.prod_tipoMaquina ?? '',
          Observacao: Response.Data.prod_observacao,
          Grupo: Response.Data.prod_grupo
        })
      }
      //form.setFieldValue('Marca', 'teste')
    } catch { console.log('oi') }

  }, []);

  useEffect(() => {
    if (MaquinaId) {
      getMaquinaById();
    }
  }, [])

  return {
    ...form,
    backActions,
    setMaquina,
    loading,
    marcaOptions,
    modeloOptions,
    handleSearchMarca,
    handleSelectMarca,
    handleSearchModelo,
    handleSelectModelo,
  };
};

export default useMaquinaCadastrar;
